const getDistanceFromElementTopToDocumentTop = (element) => {
  const box = element.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const clientTop = docEl.clientTop || body.clientTop || 0;

  return (box.top + scrollTop) - clientTop;
};

const getDistanceBetweenTopOfElements = (a, b) => {
  const aBox = a.getBoundingClientRect();
  const bBox = b.getBoundingClientRect();

  return aBox.top - bBox.top;
};

const getCurrentVerticalPosition = () => {
  return window.scrollY > 0 ? window.scrollY : document.documentElement.scrollTop;
};

const getCurrentVerticalBottomPosition = () => {
  const scrollTop = window.scrollY > 0 ? window.scrollY : document.documentElement.scrollTop
  return scrollTop + window.innerHeight;
};

// Return whether the vertical position at the top of the window is past element
const isVerticalTopPositionPastElement = (element) => {
  // Position of element from top of document
  const elementTopPosition = getDistanceFromElementTopToDocumentTop(element);
  // Current vertical position
  const currentVerticalPosition = getCurrentVerticalPosition();
  return currentVerticalPosition > elementTopPosition;
};

// Return whether the vertical position at the bottom of the window is past element
const isVerticalBottomPositionPastElement = (element) => {
  const elementTopPosition = getDistanceFromElementTopToDocumentTop(element);
  const currentVerticalBottomPosition = getCurrentVerticalBottomPosition();
  return currentVerticalBottomPosition > elementTopPosition;
};

const isSmoothScrollSupported = () => 'scrollBehavior' in document.documentElement.style;

const scrollToPosition = (position) => {
  if (isSmoothScrollSupported()) {
    window.scrollTo({ top: position, behavior: 'smooth' });
  } else {
    window.scrollTo(0, position);
  }
};

const scrollUpToElementIfNeeded = (element) => {
  // If current position is under the element we want to scroll to, then scroll up
  if (isVerticalTopPositionPastElement(element)) {
    // Position of element from top of document
    const elementTopPosition = getDistanceFromElementTopToDocumentTop(element);
    // Height of element
    const elementHeight = element.offsetHeight;
    const distanceToScrollFromTop = elementTopPosition - elementHeight;
    scrollToPosition(distanceToScrollFromTop);
  }
};

const scrollToElementOffsetTabs = (elementSelector, tabsClass) => {
  const tabsHeight = document.querySelector(tabsClass).offsetHeight;
  const element = document.querySelector(elementSelector);
  if (element) {
    const distance = getDistanceFromElementTopToDocumentTop(element) - tabsHeight;
    scrollToPosition(distance);
  }
};

const scrollToElementWithOptionalOffset = (elementSelector, offset = 0) => {
  const element = document.querySelector(elementSelector);
  if (element) {
    const distance = getDistanceFromElementTopToDocumentTop(element) - offset;
    scrollToPosition(distance);
  }
};

export {
  getDistanceFromElementTopToDocumentTop,
  getDistanceBetweenTopOfElements,
  scrollUpToElementIfNeeded,
  isVerticalTopPositionPastElement,
  isVerticalBottomPositionPastElement,
  scrollToElementOffsetTabs,
  scrollToElementWithOptionalOffset,
};
